import React from "react";
import { Badge } from "@/components/ui/badge";

const STATUS_MAP = {
  correct: { label: "Correcte", className: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  incorrect: { label: "Incorrecte", className: "bg-red-100 text-red-800 border-red-200" },
  open: { label: "Oberta", className: "bg-amber-100 text-amber-800 border-amber-200" },
  in_progress: { label: "En procés", className: "bg-blue-100 text-blue-800 border-blue-200" },
  closed: { label: "Tancada", className: "bg-gray-100 text-gray-700 border-gray-200" },
  low: { label: "Baixa", className: "bg-blue-50 text-blue-700 border-blue-200" },
  medium: { label: "Mitjana", className: "bg-amber-50 text-amber-700 border-amber-200" },
  high: { label: "Alta", className: "bg-orange-100 text-orange-800 border-orange-200" },
  critical: { label: "Crítica", className: "bg-red-100 text-red-800 border-red-200" },
  entry: { label: "Entrada", className: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  exit: { label: "Sortida", className: "bg-rose-100 text-rose-800 border-rose-200" },
  pause_start: { label: "Pausa", className: "bg-amber-100 text-amber-800 border-amber-200" },
  pause_end: { label: "Fi pausa", className: "bg-blue-100 text-blue-800 border-blue-200" },
};

export default function StatusBadge({ status }) {
  const config = STATUS_MAP[status] || { label: status, className: "bg-gray-100 text-gray-700" };
  return (
    <Badge variant="outline" className={`${config.className} border font-medium text-xs`}>
      {config.label}
    </Badge>
  );
}